import React from 'react';
import { useConnect } from '@lore/query-connect';
import PROJECT_REQUIRED_FIELDS from '../../projects/REQUIRED_FIELDS';
import EVENT_REQUIRED_FIELDS from '../../events/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { creator_tags_educator } from '../../../utils/query-helpers';

export default function AssociatedWithProjectOrEvent(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousSchools = useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfProjects',
            relation: 'users.projects',
            $where: {
              $and: PROJECT_REQUIRED_FIELDS.$and,
              ...creator_tags_educator(),
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          },
          {
            type: 'count',
            alias: 'numberOfEvents',
            relation: 'users.events',
            $where: {
              $and: EVENT_REQUIRED_FIELDS.$and,
              ...creator_tags_educator(),
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          }
        ],
        $having: {
          $or: [
            {
              numberOfProjects: {
                $gte: 1
              }
            },
            {
              numberOfEvents: {
                $gte: 1
              }
            }
          ]
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const newSchools = useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfProjects',
            relation: 'users.projects',
            $where: {
              $and: PROJECT_REQUIRED_FIELDS.$and,
              ...creator_tags_educator(),
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          },
          {
            type: 'count',
            alias: 'numberOfEvents',
            relation: 'users.events',
            $where: {
              $and: EVENT_REQUIRED_FIELDS.$and,
              ...creator_tags_educator(),
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          }
        ],
        $having: {
          $or: [
            {
              numberOfProjects: {
                $gte: 1
              }
            },
            {
              numberOfEvents: {
                $gte: 1
              }
            }
          ]
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousSchools.state === PayloadStates.FETCHING ||
    newSchools.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Associated with Project or Event"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Associated with Project or Event"
      value={newSchools.meta.totalCount}
      previousValue={previousSchools.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
